<article class="space-y-8">
    <div class="aspect-h-1 aspect-w-1">
        <app-lazy-asset
            [configuration]="featuredImageConfiguration"
            [additionalClasses]="['rounded-lg']"></app-lazy-asset>
    </div>
    <div>
        <h3 class="pb-4 font-semibold">{{ accommodation?.title }}</h3>
        <app-rich-text-document
            [document]="
                accommodation?.description?.json
            "></app-rich-text-document>
    </div>
</article>
